import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';
import { RootState } from '@lib/redux.lib/store';

export const useGetDefaultJobsBoardFilters = () => {
  const loggedInUserId = useSelector(
    (state: RootState) => state.app?.user?.profile?.id
  );

  const { data, isLoading, isError } = useQuery({
    queryKey: ['jobsBoardDefaultFilters', loggedInUserId],
    queryFn: async () => {
      const result = await PublicApplicationAPI.getJobsBoardDefaultFilters(
        loggedInUserId
      );
      return result || {};
    },
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!loggedInUserId,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
